import AuthService from '../services/auth.service.js'
import { eventBus } from "../event_bus"
import Security from "./auth.security"

var user
var security
try {
    user = JSON.parse(localStorage.getItem("user"))
    var jwt = JSON.parse(atob(user.access_token.split('.')[1]))
    security = Security.init(jwt)
} catch {
    user = null
    security = Security.init(null)
}

var status = {}
if (user) {
    status.loggedIn = true
}
else {
    status.loggedIn = false
}

var portals
try {
    portals = JSON.parse(localStorage.getItem("portals"))
} catch {
    portals = null
}

var portal
try {
    var p = JSON.parse(localStorage.getItem("portal"))
    for (var i = 0; i < portals.length; ++i) {
        var pp = portals[i]
        if (pp.id == p.id) {
            portal = pp
            break
        }
    }
} catch {
    portal = null
}

var portal_configuration 
try {
    portal_configuration = JSON.parse(localStorage.getItem("portal_configuration"))
}
catch {
    portal_configuration = {}
}

const initialState = {
    user: user,
    status: status,
    portals: portals,
    portal: portal,
    security: security,
    portal_configuration: portal_configuration,
    last_refresh: Date.now()
}

export const auth = {
    namespaced: true,
    state: initialState,
    actions: {
        login({ commit, dispatch }, data) {
            return AuthService.login(data).then(
                async (data) => {
                    if (data.success) {
                        commit("loginSuccess", data)
                        dispatch("fetchPortalConfiguration")
                    } else {
                        commit("loginFailure")
                    }
                    return Promise.resolve(data)
                },
                (error) => {
                    commit("loginFailure")
                    return Promise.reject(error)
                }
            )
        },
        loginAzure({commit, dispatch}, data) {
            return AuthService.loginAzure(data).then(
                async (data) => {
                    if (data.success){
                        commit("loginSuccess", data)
                        dispatch("fetchPortalConfiguration")
                    }else {
                        commit("loginFailure")
                    }
                    return Promise.resolve(data)
                },
                (error) => {
                    commit("loginFailure")
                    return Promise.reject(error)
                }
            );
        },
        async logout({ commit }) {
            commit("logout")
            commit("clearPortalConfiguration")
        },
        async setPortal({ commit }, portal) {
            commit("setPortal", portal)
        },
        async refreshJwtToken({ commit }) {
            return AuthService.refreshJwtToken().then(
                async (data) => {
                    if (data.success) {
                        commit("loginSuccess", data)
                        return Promise.resolve(data)
                    } else {
                        commit("loginFailure")
                        return Promise.reject()
                    }
                },
                (error) => {
                    commit("loginFailure")
                    return Promise.reject(error)
                }
            )
        },
        async setWebcodeFromUrl({ commit }) {
            if (location.hostname !== 'localhost') {
                commit("setWebcodeFromUrlHostname")
            }
            else {
                commit("setWebcodeFromUrlPath")
            }
        },
        async setPortalFromWebcode({ commit }, webcode){
            return AuthService.getPortalFromWebcode(webcode).then(
                async (portal) => {
                    if (portal !== null) {
                        commit("setPortal", portal)
                    }
                    return Promise.resolve(portal)
                }
            )
        },
        async fetchPortalConfiguration({ state, commit }) {
            if (state.portal_configuration == null || Object.keys(state.portal_configuration).length === 0) {
              try {
                return AuthService.getPortalConfiguration().then(
                    (response) => {
                        commit('setPortalConfiguration', response.data);
                    }
                )
              } catch (error) {
                console.error('Could not fetch portal configuration:', error);
              }
            }
        },
        async clearPortalConfiguration({commit}) {
            commit('clearPortalConfiguration');
        },
        async refreshPortalConfiguration({commit, dispatch}) {
            commit('clearPortalConfiguration')
            return dispatch('fetchPortalConfiguration')
        },
        async refreshLoginState({commit, dispatch, state}){
            if(state.status.loggedIn) {
                if (Date.now() - state.last_refresh > 30000) {
                    state.last_refresh = Date.now();
                    commit('refreshLoginState');
                }
                if (state.user && state.security.jwt.exp - 900 < Date.now() / 1000 && state.security.jwt.exp < Date.now() / 1000) {
                    return dispatch("refreshJwtToken");
                }
                else if (state.security.jwt.exp < Date.now() / 1000) {
                    return dispatch("logout");
                }
            }
        },
        async handleIdleState({dispatch, commit, state}){
            if(state.status.loggedIn) {
                commit('refreshLoginState')
            }
            if (state.user && state.security.jwt.exp < Date.now() / 1000) {
                return dispatch("logout")
            }
        }
    },
    mutations: {
        loginSuccess(state, data) {
            state.status.loggedIn = true
            state.user = data.user

            var jwt = JSON.parse(atob(state.user.access_token.split('.')[1]))
            var portals = JSON.parse(jwt.sys_portals)
            var selectedPortal
            if (portals.length > 1) {
                selectedPortal = portals[0]
            } else {
                selectedPortal = portals[0]
            }
            state.portals = portals
            state.portal = selectedPortal
            state.security = Security.init(jwt)

            localStorage.setItem("user", JSON.stringify(state.user))
            localStorage.setItem("portal", JSON.stringify(selectedPortal))
            localStorage.setItem("portals", JSON.stringify(portals))
            localStorage.setItem("webcode", selectedPortal.webcode)
            localStorage.setItem("timezone", jwt.timezone)
            eventBus.$emit("user_changed", state.user)
        },
        loginFailure(state) {
            state.status.loggedIn = false
            state.user = null
            state.portal = null
            state.portals = null
            state.security = Security.init(null)
            localStorage.removeItem("user")
            eventBus.$emit("user_changed", null)
        },
        setPortal(state, portal) {
            state.portal = portal
            localStorage.setItem("portal", JSON.stringify(portal))
            localStorage.setItem("webcode", portal.webcode)
        },
        logout(state) {
            state.status.loggedIn = false
            state.user = null
            state.portal = null
            state.portals = null
            state.security = Security.init(null)
            localStorage.removeItem("user")
            localStorage.removeItem("portal")
            localStorage.removeItem("portals")
            localStorage.removeItem("timezone")
            eventBus.$emit("user_changed", null)
        },
        refreshLoginState(state) {
            try {
                state.user = JSON.parse(localStorage.getItem("user"))
                if (state.user !== undefined && state.user !== null){                
                    var jwt = JSON.parse(atob(state.user.access_token.split('.')[1]))
                    state.security = Security.init(jwt)

                    state.portals = JSON.parse(localStorage.getItem("portals"))
                    var innerp = JSON.parse(localStorage.getItem("portal"))

                    for (var inneri = 0; inneri < state.portals.length; ++inneri) {
                        var innerpp = state.portals[inneri]
                        if (innerpp.id == innerp.id) {
                            state.portal = innerpp
                            break
                        }
                    }
                    state.portal_configuration = JSON.parse(localStorage.getItem("portal_configuration"))
                    state.status.loggedIn = true
                }
                else {
                    state.portal_configuration = {}
                    state.portal = null
                    state.portals = null
                    state.user = null
                    state.security = Security.init(null)
                    state.status.loggedIn = false
                    eventBus.$emit("user_changed", null)
                }
            }
            catch (ex) {
                console.log(ex);

                state.portal_configuration = {}
                state.portal = null
                state.portals = null
                state.status.loggedIn = false
                state.user = null
                state.security = Security.init(null)
                eventBus.$emit("user_changed", null)
            }
        },
        setWebcodeFromUrlHostname() {
            localStorage.removeItem('webcode')

            if (location.hostname !== 'localhost') {
                var hostnames = location.hostname.split('.')

                if (hostnames.length >= 1) {
                    if (hostnames[0].includes('-')) {
                        var webcode = hostnames[0].split('-')[0]

                        localStorage.setItem("webcode", webcode)                   
                    }               
                }
            }
        },
        setWebcodeFromUrlPath() {

            if (location.hostname === 'localhost') {
                var pathnames = location.pathname.split('/').slice(1)

                if (pathnames.length > 1) {
                    localStorage.removeItem('webcode')
                    var webcode = pathnames[0];
                    localStorage.setItem("webcode", webcode)
                }
            }
        },
        setPortalConfiguration(state, settings) {
            state.portal_configuration = settings.portal_configuration
            localStorage.setItem('portal_configuration', JSON.stringify(settings.portal_configuration))
        },
        clearPortalConfiguration(state) {
            state.portal_configuration = {}
            localStorage.removeItem('portal_configuration')
        }
    }
}